import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconButton, withStyles, AppBar, Typography, Toolbar } from 'material-ui';
import MealsSelectionHeaderStyles from './MealsSelectionHeaderStyles';
import ArrowLeftIcon from '../../../../icons/ArrowLeftIcon';
/**
 * ## Redux imports
 */
import * as passengersActions from '../../../../redux/actions/PassengersActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../../../redux/selectors/Index';

class MealsSelectionHeader extends Component {
  constructor (props) {
    super(props);

    const { passengers, activePassenger } = props;
    this.state = { passenger: selectors.passengers.getPassengerById(passengers, activePassenger) };
  }

  componentWillReceiveProps (props) {
    const { passengers, activePassenger } = props;
    this.setState({ passenger: selectors.passengers.getPassengerById(passengers, activePassenger) });
  }

  render () {
    const { title, handleClose, classes } = this.props;
    const { passenger } = this.state;
    let passengerFullName = passenger ? `${passenger.firstName} ${passenger.lastName}` : '';
    return (
      <div style={{ flexGrow: 1 }}>
        <AppBar
          position='static'
          style={{
            width: '100%',
            backgroundColor: '#ffffff',
            color: 'rgba(0, 0, 0, 0.54)',
          }}
        >
          <Toolbar>
            <IconButton color='inherit' onClick={handleClose} aria-label='Close'>
              <ArrowLeftIcon className='navbar-arrow-icon' color='rgba(0, 0, 0, 0.54)' />
            </IconButton>
            <Typography type='title' color='inherit' className={classes.flex}>
              {title} {passengerFullName}
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

MealsSelectionHeader.propTypes = {
  title: PropTypes.string,
  activePassenger: PropTypes.string,
  passengers: PropTypes.arrayOf(PropTypes.object),
  handleClose: PropTypes.func,
  classes: PropTypes.object,
};

/**
 * ## Redux boilerplate
 */
const actions = [ passengersActions ];

function mapStateToProps (state) {
  return { passengers: selectors.passengers.getPassengers(state.passengers) };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(MealsSelectionHeaderStyles)(MealsSelectionHeader)
);



// WEBPACK FOOTER //
// ./src/containers/meals/common/mealsHeader/MealsSelectionHeader.js